module.exports = __webpack_public_path__ + "static/media/GlossaryEmptyStateBackground.e22ec7a8.svg";